import React from 'react';
import styled from '@emotion/styled';

import { scaledCss } from '~/src/css';

export const Section = styled('section')(
  scaledCss({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    color: '#3d3d3d',
    backgroundColor: '#fff',
    borderStyle: 'solid',
    borderColor: '#68a5fb',
    borderWidth: [6, '6px'],
    borderRadius: [20, '20px'],
  })
);

interface SectionWithTitleProps {
  className?: string;
  title: React.ReactNode;
}
export const SectionWithTitle: React.FC<SectionWithTitleProps> = ({
  className,
  title,
  children,
}) => {
  return (
    <Section className={className}>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </Section>
  );
};

const SectionTitle = styled('h2')(
  scaledCss({
    margin: 0,
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    paddingX: '1em',
    paddingTop: '0.3em',
    paddingBottom: '0.45em',
    fontSize: [38, '38px'],
    whiteSpace: 'nowrap',
    color: '#fff',
    backgroundColor: '#5e81ff',
    borderRadius: '1em',
  })
);
